/**
 * Loads app configuration and makes it available to the front-end.
 */
(() => {
    const promise = fetch('/app-config.json').then((response) => response.json());
    window.getAppConfig = () => promise;
})();
